module.exports = __webpack_public_path__ + "img/new_1.4dd31be6.png";